"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/sv-SE.ts
var sv_SE_exports = {};
__export(sv_SE_exports, {
  AG_CHARTS_LOCALE_SV_SE: () => AG_CHARTS_LOCALE_SV_SE
});
module.exports = __toCommonJS(sv_SE_exports);
var AG_CHARTS_LOCALE_SV_SE = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] serier",
  ariaAnnounceFlowProportionLink: "l\xE4nk ${index} av ${count}, fr\xE5n ${from} till ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nod ${index} av ${count}, ${description}",
  ariaAnnounceGaugeChart: "m\xE4targraf, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkidiagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niv\xE5 ${level}[number], ${count}[number] barn, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Tryck p\xE5 Space eller Enter f\xF6r att v\xE4xla synlighet",
  ariaLabelAddHorizontalLine: "L\xE4gg till horisontell linje",
  ariaLabelAnnotationOptionsToolbar: "Alternativ f\xF6r annotering",
  ariaLabelAnnotationSettingsDialog: "Inst\xE4llningar f\xF6r anteckningar",
  ariaLabelColorPicker: "F\xE4rgv\xE4ljare",
  ariaLabelFinancialCharts: "Finansiella diagram",
  ariaLabelLegend: "Teckenf\xF6rklaring",
  ariaLabelLegendItem: "${label}, Legend objekt ${index}[number] av ${count}[number]",
  ariaLabelLegendItemUnknown: "Ok\xE4nd legendpost",
  ariaLabelLegendPageNext: "N\xE4sta legend sida",
  ariaLabelLegendPagePrevious: "F\xF6reg\xE5ende legendasida",
  ariaLabelLegendPagination: "Legend Paginerings",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maximal",
  ariaLabelNavigatorMinimum: "Minsta",
  ariaLabelNavigatorRange: "R\xE4ckvidd",
  ariaLabelRangesToolbar: "Omr\xE5den",
  ariaLabelSettingsTabBar: "Inst\xE4llningar",
  ariaLabelZoomToolbar: "Zooma",
  ariaValuePanRange: "${min}[percent0to2dp] till ${max}[percent0to2dp]",
  contextMenuDownload: "Ladda ner",
  contextMenuPanToCursor: "Panorera hit",
  contextMenuToggleOtherSeries: "V\xE4xla andra serier",
  contextMenuToggleSeriesVisibility: "V\xE4xla synlighet",
  contextMenuZoomToCursor: "Zooma hit",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Datum och pris",
  dialogHeaderDateRange: "Datumintervall",
  dialogHeaderFibonacciRange: "Fib \xC5terh\xE4mtning",
  dialogHeaderLine: "Linje",
  dialogHeaderPriceRange: "Prisklass",
  dialogHeaderText: "Text",
  dialogInputAlign: "Justering",
  dialogInputColorPicker: "F\xE4rg",
  dialogInputColorPickerAltText: "Textf\xE4rg",
  dialogInputExtendAbove: "F\xF6rl\xE4ng ovan",
  dialogInputExtendBelow: "F\xF6rl\xE4ng nedanf\xF6r",
  dialogInputExtendChannelEnd: "F\xF6rl\xE4ng kanalens slut",
  dialogInputExtendChannelStart: "Ut\xF6ka kanalstart",
  dialogInputExtendLeft: "F\xF6rl\xE4ng \xE5t v\xE4nster",
  dialogInputExtendLineEnd: "F\xF6rl\xE4ng linjens slut",
  dialogInputExtendLineStart: "F\xF6rl\xE4ng linjens start",
  dialogInputExtendRight: "Str\xE4ck ut \xE5t h\xF6ger",
  dialogInputFibonacciBands: "Bander",
  dialogInputFibonacciBandsAltText: "Fibonacci-band",
  dialogInputFillColorPicker: "Fyll",
  dialogInputFillColorPickerAltText: "Fyllnadsf\xE4rg",
  dialogInputFontSize: "Storlek",
  dialogInputFontSizeAltText: "Teckenstorlek",
  dialogInputLineStyle: "Streck",
  dialogInputPosition: "Position",
  dialogInputReverse: "Omv\xE4nd",
  dialogInputShowFill: "Visa fyllning",
  dialogInputStrokeWidth: "Vikt",
  dialogInputStrokeWidthAltText: "Linjens vikt",
  iconAltTextAlignCenter: "Centrera",
  iconAltTextAlignLeft: "V\xE4nster",
  iconAltTextAlignRight: "H\xF6ger",
  iconAltTextClose: "St\xE4ng",
  iconAltTextLineStyleDashed: "L\xE5ngstreckad",
  iconAltTextLineStyleDotted: "Kortstreckad",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Botten",
  iconAltTextPositionCenter: "Center",
  iconAltTextPositionTop: "Topp",
  inputTextareaPlaceholder: "L\xE4gg till text",
  measurerDateRangeBars: "${value}[number] staplar",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Laddar data...",
  overlayNoData: "Inga data att visa",
  overlayNoVisibleSeries: "Inga synliga serier",
  overlayUnsupportedBrowser: "Inkompatibel webbl\xE4sarversion. Var god uppgradera din webbl\xE4sare.",
  seriesHistogramTooltipCount: "${yName} (antal)",
  seriesHistogramTooltipFrequency: "Frekvens",
  seriesHistogramTooltipMean: "${yName} (medelv\xE4rde)",
  seriesHistogramTooltipSum: "${yName} (summa)",
  toolbarAnnotationsArrow: "Pil",
  toolbarAnnotationsArrowDown: "Pilen ned",
  toolbarAnnotationsArrowUp: "Pil Upp",
  toolbarAnnotationsCallout: "Anm\xE4rkning",
  toolbarAnnotationsClearAll: "Rensa alla",
  toolbarAnnotationsComment: "Kommentar",
  toolbarAnnotationsDatePriceRange: "Datum och pris",
  toolbarAnnotationsDateRange: "Datumintervall",
  toolbarAnnotationsDelete: "Ta bort",
  toolbarAnnotationsDisjointChannel: "Oberoende Kanal",
  toolbarAnnotationsDragHandle: "Dra Verktygsf\xE4lt",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib-retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib baserat p\xE5 trend",
  toolbarAnnotationsFillColor: "Fyllnadsf\xE4rg",
  toolbarAnnotationsHorizontalLine: "Horisontell linje",
  toolbarAnnotationsLineAnnotations: "Trendlinjer",
  toolbarAnnotationsLineColor: "Linjef\xE4rg",
  toolbarAnnotationsLineStrokeWidth: "Linjens tjocklek",
  toolbarAnnotationsLineStyle: "Linjestil",
  toolbarAnnotationsLock: "L\xE5s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE4tverktyg",
  toolbarAnnotationsNote: "Notering",
  toolbarAnnotationsParallelChannel: "Parallell kanal",
  toolbarAnnotationsPriceRange: "Prisspann",
  toolbarAnnotationsQuickDatePriceRange: "M\xE4ta",
  toolbarAnnotationsSettings: "Inst\xE4llningar",
  toolbarAnnotationsShapeAnnotations: "Pilar",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textnoteringar",
  toolbarAnnotationsTextColor: "Textf\xE4rg",
  toolbarAnnotationsTextSize: "Textstorlek",
  toolbarAnnotationsTrendLine: "Trendlinje",
  toolbarAnnotationsUnlock: "L\xE5s upp",
  toolbarAnnotationsVerticalLine: "Vertikal linje",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xE5nad",
  toolbarRange1Year: "1\xC5",
  toolbarRange1YearAria: "1 \xE5r",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 m\xE5nader",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\xE5nader",
  toolbarRangeAll: "Alla",
  toolbarRangeAllAria: "Alla",
  toolbarRangeYearToDate: "\xC5TD",
  toolbarRangeYearToDateAria: "\xC5r till idag",
  toolbarSeriesTypeCandles: "Ljus",
  toolbarSeriesTypeDropdown: "Diagramtyp",
  toolbarSeriesTypeHighLow: "H\xF6g L\xE5g",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hollow Candles",
  toolbarSeriesTypeLine: "Linje",
  toolbarSeriesTypeLineWithMarkers: "Linje med mark\xF6rer",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Steg Linje",
  toolbarZoomPanEnd: "Panorera till slutet",
  toolbarZoomPanLeft: "Panorera v\xE4nster",
  toolbarZoomPanRight: "Panorera h\xF6ger",
  toolbarZoomPanStart: "Panorera till b\xF6rjan",
  toolbarZoomReset: "\xC5terst\xE4ll zoom",
  toolbarZoomZoomIn: "Zooma in",
  toolbarZoomZoomOut: "Zooma ut",
  tooltipPaginationStatus: "${index}[number] av ${count}[number]"
};
//# sourceMappingURL=sv-SE.cjs.js.map
